/* MTO 2026-10-15: ürün galerisi mobil noktalı gezinme (referans: tps-urun-sayfasi.html).
   Nokta sayısı görünen slaytlardan hesaplanır (varyanta göre gizlenen medya sayılmaz); aktif nokta
   kaydırma konumundan bulunur. Dekoratif (aria-hidden) — konum bilgisi galerinin kendi durum alanında. */
if (!customElements.get('tps-gallery-dots')) {
  customElements.define('tps-gallery-dots', class TpsGalleryDots extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('product-gallery');
      this.slider = this.gallery && this.gallery.querySelector('.slider');
      if (!this.slider) return;
      this.sync = this.sync.bind(this);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.slider.addEventListener('scroll', this.onScroll, { passive: true });
      this.gallery.addEventListener('slideChanged', this.sync);
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.sync();
    }

    disconnectedCallback() {
      if (!this.slider) return;
      this.slider.removeEventListener('scroll', this.onScroll);
      this.gallery.removeEventListener('slideChanged', this.sync);
      window.removeEventListener('resize', this.onScroll);
    }

    sync() {
      const slides = Array.from(this.slider.children).filter((el) => el.offsetWidth > 0);
      const count = slides.length;
      if (count !== this.children.length) {
        this.replaceChildren(...slides.map(() => document.createElement('i')));
      }
      this.hidden = count < 2;
      if (count < 2) return;
      const step = slides[1].offsetLeft - slides[0].offsetLeft || this.slider.clientWidth;
      const index = Math.min(count - 1, Math.max(0, Math.round(this.slider.scrollLeft / step)));
      Array.from(this.children).forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }
  });
}
